export const PostGridEvent = Object.freeze({
  OPEN_POST: "post_grid_open_post",
});
